<template>
    <v-card
            min-width="450"
            class="mt-2"
            elevation="0"
    >
        <v-card-title>ADS CONFIGURATION</v-card-title>
        <v-card
                class="pa-0 ma-0"
                elevation="1">
            <v-row class="pt-0 pb-0">
                <v-col cols="9" class="pl-5">
                    <div class="font-weight-black pl-2 pr-3 pt-2">Banner</div>
                </v-col>
                <v-col>
                    <v-switch
                            v-model="adsConfigData.isBannerEnabled"
                            class="pt-0 mt-2"
                    >
                    </v-switch>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="9" class="pl-5">
                    <div class="font-weight-black pl-2 pr-3 pt-2">Interstitial When Popup</div>
                </v-col>
                <v-col>
                    <v-switch
                            v-model="adsConfigData.isEnabledInterstitialWhenPopup"
                            class="pt-0 mt-2"
                    >
                    </v-switch>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="9" class="pl-5">
                    <div class="font-weight-black pl-2 pr-3 pt-2">Counter Popup for a Interstitial</div>
                </v-col>
                <v-col>
                    <v-text-field
                            v-model="adsConfigData.numPopupBeforeDisplayInterstitial"
                            class="mt-0 pt-0"
                            type="number"
                            min="1"
                            max="10"
                            :disabled="!adsConfigData.isEnabledInterstitialWhenPopup"
                            @change="onInputChanged"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="9" class="pl-5">
                    <div class="font-weight-black pl-2 pr-3 pt-2">Interstitial When Open Menu</div>
                </v-col>
                <v-col>
                    <v-switch
                            v-model="adsConfigData.isEnabledInterstitialWhenOpenInventory"
                            class="pt-0 mt-2"
                    >
                    </v-switch>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="9" class="pl-5">
                    <div class="font-weight-black pl-2 pr-3 pt-2">Counter Open for a Interstitial</div>
                </v-col>
                <v-col>
                    <v-text-field
                            v-model="adsConfigData.numInventoryBeforeDisplayInterstitial"
                            class="mt-0 pt-0"
                            type="number"
                            min="1"
                            max="10"
                            :disabled="!adsConfigData.isEnabledInterstitialWhenOpenInventory"
                            @change="onInputChanged"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card>
        <v-card-actions class="pt-5 pb-0">
            <v-btn color="blue darken-1" text @click="didClose">Close</v-btn>
            <v-btn color="red darken-1" text @click="didReset">Reset</v-btn>
            <v-btn color="green darken-1" text @click="didSave">Save</v-btn>
            <v-btn color="orange darken-1" text @click="didPush">Push to {{this.environmentName}}</v-btn>
        </v-card-actions>
        <v-overlay :value="isLoading">
            <v-progress-circular
                    indeterminate
                    size="64"
            ></v-progress-circular>
        </v-overlay>
        <PopupMessage v-if="messageAlert!==''"
                      :pColor="messageColor"
                      :pTimeout="600"
                      @onClose="messageAlert=''"
        >
            {{messageAlert}}
        </PopupMessage>
    </v-card>
</template>

<script>
    import lodash from 'lodash';
    import UnityServiceApi from '@/unity-service-dashboard/api/UnityServiceApi';
    import PopupMessage from "@/item-editor/modules/PopupMessage/PopupMessage";

    export default {
        components: {
            PopupMessage
        },
        data() {
            return {
                isLoading: false,
                messageAlert: '',
                messageColor: 'orange',
                adsConfigData: {},
            };
        },
        methods:{

            async init(){
                this.isLoading = true;
                this.adsConfigData = lodash.cloneDeep(this.$store.state.adsConfig);
                this.isLoading = false;
            },

            async didSave(){
                if (confirm(`Are you sure you want to save config?`)) {
                    this.isLoading = true;
                    this.onInputChanged();
                    this.$store.commit(this.$store.state.commitActions.PUSH_ADS_CONFIG, lodash.cloneDeep(this.adsConfigData));
                    this.setAlertMessage("Save Success", false);
                    this.isLoading = false;
                }
            },

            onInputChanged(){
                this.adsConfigData.numPopupBeforeDisplayInterstitial = parseInt(this.adsConfigData.numPopupBeforeDisplayInterstitial);
                this.adsConfigData.numInventoryBeforeDisplayInterstitial = parseInt(this.adsConfigData.numInventoryBeforeDisplayInterstitial);
            },

            didClose(){
                this.$emit('close');
            },

            didReset(){
                if (confirm('Are you sure you want to reset config from Last saved?')) {
                    this.init();
                    this.setAlertMessage("Reset to last Success", false);
                }
            },

            async didPush(){
                let envName = this.environmentName;
                if (confirm(`Are you sure you want to push config to UGS in environment Name: ${envName}?`)) {
                    this.isLoading = true;
                    UnityServiceApi.updateRemoteConfig(this.$store.state.adsConfig, 'adsConfig', this.$store.state.ugsSetting.environmentId)
                        .then(result => {
                            this.setAlertMessage(result.data.message, result.data.status !== 200);
                            setTimeout(() => {
                                this.isLoading = false;
                            }, 1500);

                        })
                        .catch(error => {
                            this.setAlertMessage('Failed to add remote config: '+error, true);
                            setTimeout(() => {
                                this.isLoading = false;
                            }, 200);
                        });
                }
            },

            setAlertMessage(msg, isError){
                this.messageAlert = msg;
                if(isError){
                    this.messageColor = "red";
                } else {
                    this.messageColor = "success";
                }
            }
        },
        computed: {
            environmentName(){
                return this.$store.state.ugsSetting.environmentName;
            }
        },
        created() {
            this.init();
        }
    };
</script>